// extracted by mini-css-extract-plugin
module.exports = {"root":"TeUcW","TextSeparatorsMenuButtonNSkin":"_1MIsd","textSeparatorsMenuButtonNSkin":"_1MIsd","linkElement":"_1uwsg","label":"_2VLDA","wrapper":"_3GwRI"};